import {
  EnumRichiestaDTOStato,
  RichiestaDTO,
  TipoDomandaDTO,
  useGetFrontRichiesteIdIntegrate,
} from '@framework/api-client';
import { useCurrentUser } from '@framework/auth';
import {
  DelegationMachine,
  IDelegationData,
  SubmissionLogic,
} from '@framework/frontoffice-submission';

/**
 * Ottiene lo stato di integrazione di una richiesta, se è possibile integrare e
 * se ci sono integrazioni.
 */
export function useSubmissionsIntegrationsState(
  inquiry: TipoDomandaDTO | null | undefined,
  submission: RichiestaDTO | null | undefined,
  delegationData: IDelegationData,
) {
  const currentUser = useCurrentUser();

  const integrationsResult = useGetFrontRichiesteIdIntegrate(
    submission?.id ?? '',
    { query: { enabled: submission?.id != null } },
  );

  // Scarico le integrazioni per limitare FE la possibilità di crearne di nuove.
  // Infatti, se ci sono integrazioni in bozza, non è possibile crearne altre.
  // Questa informazione non è codificata nel BE, quindi la calcoliamo qui.
  const hasIntegrationDrafts =
    integrationsResult.data != null &&
    integrationsResult.data?.some(
      submission => submission.stato === EnumRichiestaDTOStato.BOZZA,
    ) &&
    integrationsResult.data?.length > 1;

  const draftIntegrationId = integrationsResult.data?.find(
    submission => submission.stato === EnumRichiestaDTOStato.BOZZA,
  )?.id;

  // Controlliamo se è possibile integrare la richiesta
  const canIntegrate =
    SubmissionLogic.canIntegrate(inquiry, submission) &&
    !hasIntegrationDrafts &&
    DelegationMachine.can(delegationData, '.canIntegrate', currentUser).allowed;

  const isIntegrated = submission?.stato === EnumRichiestaDTOStato.INTEGRATA;

  const hasIntegrations = SubmissionLogic.hasIntegrations(submission);

  // Mostriamo la tab delle integrazioni solo se ci sono integrazioni.
  // Valutiamo anche il caso in cui ci sono, ma in bozza.
  const shouldShowIntegrationsTab = hasIntegrations || hasIntegrationDrafts;

  return {
    isIntegrated,
    canIntegrate,
    hasIntegrations,
    integrationsResult,
    hasIntegrationDrafts,
    shouldShowIntegrationsTab,
    draftIntegrationId,
  };
}
